import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { createUseStyles } from 'react-jss';
import CollectionContext from 'components/Collection/CollectionContext';

import styles from './CollectionLoginModal.styles';
import Button from 'components/Button';
import ButtonTypes from 'components/Button/Button.const';
import CrossIcon from 'components/svg/Cross';
import { navigateToRegisterScreen, navigateToLoginScreen } from 'actions/gigya-router-actions';

const useStyles = createUseStyles(styles, { name: 'CollectionLoginModal' });

interface CollectionLoginModalProps {
  className?: string;
  icon?: JSX.Element;
  title: string;
  'data-testid': string;
}

const CollectionLoginModal = (props: CollectionLoginModalProps): JSX.Element => {
  const { icon, title, ...rest } = props;
  const { isCollectionModalClosed } = useContext(CollectionContext);

  const dispatch = useDispatch();
  const classes = useStyles();

  const onLogin = () => {
    dispatch(navigateToLoginScreen());
  };
  const onRegister = () => dispatch(navigateToRegisterScreen());
  const onCloseCollectionModal = () => {
    isCollectionModalClosed();
    sessionStorage.setItem('isCollectionModalClosed', 'true');
  };
  return (
    <>
      <div className={classes.container} data-testid={rest['data-testid']}>
        <div
          role="presentation"
          onClick={onCloseCollectionModal}
          className={classes.closeIcon}
          data-testid="collection-login-close-btn"
        >
          <CrossIcon />
        </div>
        <span className={classes.icon}>{icon}</span>
        <span className={classes.title}>{title}</span>
        <div className={classes.auth}>
          <Button
            className={classes.authButton}
            data-testid="collection-login-modal-login-btn"
            type={ButtonTypes.SECONDARY}
            onClick={onLogin}
            text="Inloggen"
          />
          <Button
            data-testid="collection-login-modal-register-btn"
            type={ButtonTypes.PRIMARY}
            onClick={onRegister}
            text="Registreren"
          />
        </div>
      </div>
    </>
  );
};

export default CollectionLoginModal;
